import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import Cookies from 'universal-cookie';
import ReactGA from 'react-ga';
import PropTypes from 'prop-types';

// Material UI
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Typography from '@material-ui/core/Typography';
import DialogContentText from '@material-ui/core/DialogContentText';
import ExpandMoreIcon from '@material-ui/icons/ExpandMoreRounded';
import Divider from '@material-ui/core/Divider';
import InfoIcon from '@material-ui/icons/InfoRounded';
import Avatar from '@material-ui/core/Avatar';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';
import SvgIcon from '@material-ui/core/SvgIcon';
import Chip from '@material-ui/core/Chip';
// import Badge from '@material-ui/core/Badge';

// Material UI Icons
import CreateIcon from '@material-ui/icons/CreateRounded';
import BallotIcon from '@material-ui/icons/BallotRounded';
import BallotOutlinedIcon from '@material-ui/icons/BallotOutlined';
import NatureIcon from '@material-ui/icons/NatureRounded';
import PhotoIcon from '@material-ui/icons/PhotoRounded';
import GPSFixedIcon from '@material-ui/icons/GpsFixedRounded';
import HowToRegRoundedIcon from '@material-ui/icons/HowToRegRounded';
import PinDropRoundedIcon from '@material-ui/icons/PinDropRounded';
import LocationOnIcon from '@material-ui/icons/LocationOnRounded';
import OwnersIcon from '@material-ui/icons/SupervisorAccountRounded';

// Moment
import moment from 'moment';

// Components
import CircularSpinner from '../../components/UI/CircularSpinner/CircularSpinner';
import { getDistanceFromLatLngInKm } from '../../maps/Utility/UtilityFunctions';

import * as actions from '../../store/actions/index';

// Custom icons
            // <path d="M21.0971253,12.3244162 C21.1175806,11.979738 21.1129261,11.63457 21.0471506,11.2936889 C21.0010956,11.0533697 20.9252762,10.825544 20.7497525,10.6430386 C20.5677369,10.4534289 20.3368491,10.358379 20.085506,10.3228578 C19.8253439,10.2857443 19.5617521,10.2624718 19.2990177,10.2558575 C18.8831747,10.2450787 18.4667193,10.2529178 18.0505088,10.2529178 C17.9192028,10.2529178 17.9189579,10.2531628 17.9189579,10.3809166 L17.9178555,13.7826226 L17.917978,13.8156941 C17.9165081,13.882082 17.9391682,13.9071918 18.0071484,13.9062119 C18.5590744,13.8988627 19.1112453,13.8999651 19.6628038,13.8856341 C19.9212511,13.8788973 20.1772487,13.8361494 20.4184254,13.732648 C20.7726575,13.5806417 20.9583476,13.2947573 21.0287776,12.9306038 C21.0669935,12.7313176 21.0851216,12.5272545 21.0971253,12.3244162 Z M22.9895478,11.6560052 C23.0095132,12.1254974 23.0090232,12.5964595 22.9136059,13.0601949 C22.8164738,13.5317695 22.6208623,13.9532469 22.2628331,14.2866562 C21.9823381,14.5481657 21.6457441,14.7099709 21.2837953,14.8227813 C20.8790986,14.9490653 20.4628882,15.0230474 20.0407983,15.0322339 C19.1084281,15.0523218 18.1759354,15.0559964 17.2435651,15.0650604 C16.9906297,15.0676326 16.7374493,15.0673876 16.4845139,15.0643255 C16.4175135,15.0632231 16.3481859,15.0540366 16.2840028,15.0351736 C16.1460826,14.9947529 16.07651,14.8976208 16.071733,14.7570059 L16.071733,9.40959555 C16.0773674,9.2334594 16.1963022,9.1129323 16.3757455,9.10595054 C16.3866468,9.10546059 16.3975482,9.10570557 16.408327,9.10570557 C17.5211204,9.106318 18.6335464,9.09651905 19.7460949,9.11170743 C20.3618365,9.12003653 20.9713313,9.20247021 21.5506943,9.4343379 C22.1448782,9.67208496 22.5685603,10.0798438 22.7947936,10.6839492 C22.9122586,10.9973932 22.9753393,11.3240657 22.9895478,11.6560052 Z M15.1302988,9.09480423 L15.1302988,15.0504845 C14.9044329,15.0523218 14.6784446,15.0541591 14.4525788,15.0564863 C14.1996433,15.0589361 13.9464629,15.0588136 13.693405,15.0556289 C13.6265272,15.054649 13.5571996,15.0454625 13.4930165,15.026477 C13.3506867,14.984954 13.2795218,14.8837798 13.2791543,14.7356931 C13.2786644,14.396037 13.2793993,12.9444448 13.2786644,12.3917839 C12.7367824,12.414199 12.1953903,12.4508226 11.6546107,12.4958978 C11.1484948,12.5384008 10.6444613,12.6041762 10.1392028,12.6554982 C10.0668131,12.6629699 10.0503998,12.6916319 10.0506448,12.7580198 C10.0524821,13.3950741 10.0518697,14.0321284 10.0516247,14.6689378 C10.0516247,14.877533 9.88577745,15.0497495 9.67730475,15.0541591 C9.30286232,15.0619982 8.92792994,15.0613858 8.55373248,15.0541591 C8.33190872,15.0497495 8.21873083,14.9533524 8.19386599,14.7610479 C8.19031387,14.7334884 8.18847656,14.7038465 8.18847656,14.6724899 C8.18823159,14.1419992 8.18847656,13.6115084 8.18847656,13.0811402 L8.18847656,12.9602456 L8.18823159,12.9602456 L8.18823159,12.9596332 C8.06109019,12.9826607 7.95195437,13.0012787 7.8433085,13.022469 C6.60116891,13.2662179 5.37678992,13.5786819 4.17004905,13.9612085 C3.26474842,14.2483178 2.37279886,14.5715607 1.49162815,14.9248129 C1.4089495,14.9577619 1.38138995,14.9371841 1.34917589,14.8242512 C1.27115174,14.5507379 1.17059,14.283349 1.03609939,14.0327409 C0.98061283,13.9289945 0.987962044,13.8938407 1.06598619,13.8628515 C2.15832431,13.4286355 3.26438096,13.0344727 4.39126038,12.6987361 C5.3536399,12.4121168 6.32618584,12.1670205 7.30951062,11.9640597 C7.5704077,11.9101655 7.8320397,11.8592109 8.09452912,11.8143807 C8.17279824,11.8011521 8.18970143,11.7663659 8.18945646,11.695201 C8.18761916,10.9690987 8.18847656,10.2426289 8.18847656,9.51640412 C8.18847656,9.48651732 8.18798662,9.45650803 8.18859905,9.42674372 C8.19178371,9.26640837 8.31610791,9.13314263 8.47534087,9.11427965 C8.68405854,9.08941481 8.89338864,9.06920447 9.10284122,9.04985154 C9.31082397,9.03074359 9.51929666,9.00894092 9.72801433,9.00036684 C9.7787239,8.99828456 9.82404405,9.00514383 9.86409727,9.01898485 C9.86544462,9.01971977 9.86666949,9.02057718 9.86826182,9.02106713 C9.88565496,9.02755893 9.9020682,9.03515312 9.91701161,9.04446212 C9.92497325,9.04923911 9.93158755,9.05548594 9.93893676,9.06112034 C9.94665343,9.06687722 9.95473757,9.07226665 9.96135186,9.07900343 C9.97151827,9.08880238 9.98009236,9.09994868 9.98842146,9.11146245 C9.99136115,9.11538203 9.9946683,9.11856669 9.99711803,9.12273125 C10.006917,9.1371847 10.0150011,9.15323048 10.0221054,9.17025616 C10.0227178,9.171726 10.0235752,9.17307336 10.0239427,9.17442072 C10.0417033,9.21765859 10.0516247,9.26738827 10.0516247,9.32385473 C10.0518697,10.0146808 10.0516247,10.7055069 10.0518697,11.3965779 C10.0518697,11.4601486 10.1036816,11.5070611 10.1670074,11.5006918 C10.7298346,11.4438579 11.291927,11.3832269 11.8553667,11.3343546 C12.2178054,11.302753 12.5818365,11.2891569 12.9452551,11.2675992 C13.0211969,11.2629447 13.0972613,11.2521659 13.1728357,11.2552281 C13.2604138,11.2586577 13.2857686,11.227546 13.2797668,11.1256369 C13.2642109,10.8651073 13.2531871,10.6045777 13.2673956,10.3440481 C13.2841763,10.0367284 13.2769496,9.72267205 13.2791543,9.41033047 C13.2803792,9.22855992 13.4018862,9.10460319 13.5847591,9.09725397 C13.5956605,9.09688651 13.6065618,9.097009 13.6173407,9.097009 C14.1217417,9.09725397 14.6260202,9.09541667 15.1302988,9.09480423 Z"></path>

function ForestOtherIcon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M19.4245678,5.11176471 C18.1512451,2.9 16.1312924,2 12.4444444,2 C8.75759653,2 6.69712893,2.92941176 5.44695758,5.11176471 C4.42829944,6.89411765 4,8.24117647 4,12 C4,15.7588235 4.42829944,17.1058824 5.44695758,18.8882353 C6.69712893,21.0705882 8.79232351,22 12.4444444,22 C16.0965654,22 18.1512451,21.1 19.4245678,18.8882353 C20.4605894,17.0882353 20.8888889,15.7294118 20.8888889,12 C20.8888889,8.27058824 20.4374381,6.88235294 19.4245678,5.11176471 Z M8.59122927,7.74574931 L12.3040218,3.92012653 C12.4997349,3.73032819 12.8105734,3.73032819 13.0062865,3.92012653 L16.7421041,7.7694741 C16.9378172,7.97113484 16.9378172,8.29141953 16.7421041,8.49308027 C16.546391,8.694741 16.2355525,8.694741 16.0398394,8.49308027 L13.8236764,6.209569 C13.7891388,6.17398181 13.5876695,5.94266509 13.3574188,6.06128905 C13.2480497,6.11466983 13.1501931,6.2036378 13.1501931,6.46461052 L13.1501931,10.4444444 L12.1543589,10.4444444 L12.1543589,6.46461052 C12.1543589,6.23329379 12.0737711,6.12060103 11.941377,6.06128905 C11.6996137,5.94859628 11.5154132,6.17398181 11.4808756,6.2155002 L9.2934939,8.46935548 C9.10353707,8.67101621 8.78694236,8.67101621 8.59122927,8.46935548 C8.59122927,8.46935548 8.59122927,8.46935548 8.59122927,8.46935548 C8.39551617,8.26769474 8.39551617,7.94741004 8.59122927,7.74574931 C8.59122927,7.74574931 8.59122927,7.74574931 8.59122927,7.74574931 Z M19.1111111,12.762771 L12.936885,12.762771 L12.936885,13.9724117 L16.525078,17.5610126 C16.7209023,17.7568592 16.7209023,18.0679097 16.525078,18.2637563 C16.525078,18.2637563 16.5193185,18.2695164 16.5193185,18.2695164 C16.3292537,18.4596028 16.0239981,18.4596028 15.8281737,18.2752766 L13.6107511,16.0576019 C13.5013199,15.9539184 13.3400528,15.8099136 13.1269498,15.9078369 C13.0347972,15.9481583 12.9311255,16.0230408 12.925366,16.3052903 L12.925366,19.7268455 C12.925366,20.0033348 12.7007439,20.2222222 12.4300456,20.2222222 C12.1535877,20.2222222 11.9347252,19.9975747 11.9347252,19.7268455 L11.9347252,16.2822495 C11.9347252,16.0172806 11.8022558,15.9251175 11.7043437,15.8905563 C11.5027598,15.821434 11.3472522,15.9596786 11.2781377,16.0345612 L9.0837533,18.2291951 C8.8936885,18.4308019 8.57691385,18.4423223 8.38108951,18.2522359 C8.37532997,18.2464757 8.36957043,18.2464757 8.36957043,18.2407155 C8.1737461,18.0448689 8.1737461,17.7338184 8.38108951,17.5264514 L11.9520038,13.9608913 L11.9520038,12.7742913 L5.77777778,12.7742913 L5.77777778,11.7777778 L19.1111111,11.7777778 L19.1111111,12.762771 Z"></path>
        </SvgIcon>
    );
}

const cookies = new Cookies();

const styles = (theme) => ({
    cardContent: {
        paddingTop: 0,
        paddingLeft: 16,
        paddingRight: 16,
        paddingBottom: 0,
        marginBottom: 0,
        position: 'relative',
        margin: 'auto',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        maxHeight: '400px',
        overflow: 'auto',
    },
    icon: {
        color: theme.palette.primary.dark,
    },
    iconHD: {
        color: '#005537',
    },
    avatar: {
        backgroundColor: 'white',
    },
    root: {
        border: '1px solid #c7e8bc',
    },
    indicator: {
        backgroundColor: 'white',
    },
    padding: {
        padding: theme.spacing(0, 2),
    },
    customBadge: {
        backgroundColor: theme.palette.primary.main,
        color: "white",
    },
    bbutton: {
        display: 'flex',
        alignItems: 'center',
    },
    wrapper: {
        position: 'relative',
    },
    // buttonProgress: {
    //     color: '#5EBD3E',
    //     position: 'absolute',
    //     left: '50%',
    //     marginTop: 6,
    //     marginLeft: -10,
    // },
    chip: {
        margin: 2,
    },
});

class NotesWidget extends Component {
    constructor(props) {
        super(props);
        const notesWidgetState = cookies.get('notesWidgetState');
        this.state = {
            secondary: true,
            dense: true,
            open: notesWidgetState === 'close' ? false : true,
            tag: '',
            setNotesToDisp: false,
            todoFilterValue: null,
            myCurrentPosition: null,
            loadingCloseToMe: false,
        };
    }

    componentDidMount() {
        // if (this.props.currentAuthUser.packages && this.props.currentAuthUser.packages.includes('taskPlanning')) {
        //     this.props.onSetFilterTag("todo")
        // }
        if (this.props.currentAuthUser.userTags && !this.props.currentAuthUser.userTags.some(tag => ["Admin", "Skovfoged", "Skovejer"].includes(tag))) {
            this.props.onSetFilterTag("todo")
        }
    }

    filterNoteListByLitra = (litraNr) => {
        let filteredNotesList = this.props.notes;
        filteredNotesList = filteredNotesList.filter((note) => {
            return note.litraNr === litraNr;
        });
        return filteredNotesList;
    }

    handleTodoTabChange = (event, newValue) => {
        this.setState({ todoFilterValue: newValue, setNotesToDisp: true });
        // Send event to Analytics
        ReactGA.event({
            category: 'NotesWidget',
            action: `Set todo filter value: ${newValue}`,
            label: `User: ${this.props.currentAuthUser.name}`
        });
    }

    createNoteListContent = (props, divider) => {
        const { classes } = this.props;
        if (props.private && props.userUID !== this.props.currentAuthUser.id) {
            return null
        }
        // Get forest name
        let frstName = '';
        if (this.props.customerList) {
            const checkForForestName = this.props.customerList[props.forestId];
            frstName = checkForForestName ? checkForForestName.forestName : '';
        }

        // Distance to me text
        let distanceText = null;
        if (this.props.filterTodoDistanceToMe && this.state.myCurrentPosition) {
            const notePos = { lat: props.latlng.lat, lng: props.latlng.lng };
            const myPos = { lat: this.state.myCurrentPosition.latitude, lng: this.state.myCurrentPosition.longitude };
            // Distance to note
            const distance = getDistanceFromLatLngInKm(myPos, notePos);
            // Set distance text
            if (distance > 5) {
                distanceText = distance.toFixed(0) + " km";
            } else {
                distanceText = (distance * 1000).toFixed(0) + " m";
            }
        }

        const prim =
            <Typography
                variant="caption"
                style={{ color: '#747474', display: 'block', marginTop: 4, marginBottom: -2 }}
                component={'span'}
            >
                {moment(props.creationDate ? props.creationDate : props.date).format('DD[-]MM[-]YYYY HH:mm')}
            </Typography>

        const sec =
            <Fragment>
                <Typography
                    variant="subtitle1"
                    noWrap
                    style={{ color: '#000000', display: 'block', marginBottom: - 6 }}
                    component={'span'}
                >
                    {props.title}
                </Typography>
                <Typography
                    variant="body2"
                    noWrap
                    style={{ color: '#000000', display: 'block' }}
                    component={'span'}
                >
                    {props.text}
                </Typography>
                <Typography
                    variant="caption"
                    style={{ color: '#747474' }}
                    component={'span'}
                    gutterBottom
                >
                    {frstName !== '' ? frstName + ', ' + props.from : props.from}
                </Typography>
                {distanceText && <span style={{ display: 'flex' }}>
                    <LocationOnIcon style={{ color: '#41842b', height: 14, width: 14 }} />

                    <Typography variant="caption" style={{ color: '#41842b' }}>
                        {distanceText}
                    </Typography>
                </span>}
            </Fragment>

        return (
            <ListItem
                button
                divider={divider}
                component={Link}
                to={{
                    pathname: `/Notes/${props.id}`,
                    state: {
                        title: props.title,
                        date: props.date,
                        creationDate: props.creationDate ? props.creationDate : props.date,
                        text: props.text,
                        from: props.from,
                        images: props.images,
                        id: props.id,
                        userUID: props.userUID,
                        latlng: props.latlng,
                        private: props.private,
                        markerId: props.markerId,
                        forestId: props.forestId,
                        litraNr: props.litraNr,
                        tag: props.tag,
                        todoStatus: props.todoStatus,
                        todoTeam: props.todoTeam,
                        prevPage: "noteList",
                    }
                }}
                onClick={() => this.props.onSetFlyToNoteData(props)}
                style={{ paddingLeft: 6, marginBottom: 0, paddingTop: 0 }}
            >
                <ListItemAvatar>
                    <Avatar className={classes.avatar} classes={{ root: classes.root }}>
                        {this.renderIcon(props.tag, props.todoStatus)}
                    </Avatar>
                </ListItemAvatar>
                <ListItemText
                    primary={prim}
                    secondary={sec}
                />
            </ListItem>
        );
    }

    renderIcon(tag, todoStatus) {
        const { classes } = this.props;
        if (tag === 'todo') {
            switch (todoStatus) {
                case 'Ikke planlagt': return (<BallotOutlinedIcon className={classes.icon} style={{ color: '#A3A3A3' }} />);
                case 'Ikke startet': return (<BallotIcon className={classes.icon} style={{ color: '#A3A3A3' }} />);
                case 'I gang': return (<BallotIcon className={classes.icon} style={{ color: '#009CDF' }} />);
                case 'Udført': return (<BallotIcon className={classes.icon} />);
                default: return (<BallotIcon className={classes.icon} />);
            }
        } else {
            switch (tag) {
                case 'skoven': return (<NatureIcon className={classes.icon} />);
                case 'jagt': return (<GPSFixedIcon className={classes.icon} />);
                case 'billeder': return (<PhotoIcon className={classes.icon} />);
                case 'andet': return (<CreateIcon className={classes.icon} />);
                case 'privat': return (<CreateIcon className={classes.icon} />);
                case 'skovejere': return (<OwnersIcon className={classes.icon}/>)
                case 'hededanmark': return (<ForestOtherIcon className={classes.iconHD} />);
                default: return (<CreateIcon className={classes.icon} />);
            }
        }
    }

    displayNotesList = (noteList, N) => {
        // Check if list is empty
        if (noteList.length === 0) {
            return (
                <div style={{ height: 50, display: 'flex', alignItems: 'center' }}>
                    <Typography component="p" variant="body1" color="textSecondary">
                        Der er ingen noter under den valgte kategori
                    </Typography>
                </div>
            )
        }
        // Set length of list and return content
        let Len = N;
        if (noteList.length < Len) {
            Len = noteList.length;
        }
        const ntsList = noteList.map((note, i) => {
            let divider = i < Len - 1;
            return <div key={note.id}>{this.createNoteListContent(note, divider)}</div>
        });

        return ntsList;
    }

    handleFilterTagClick = (tag) => {
        if (tag !== this.props.filterTag) {
            this.props.onSetFilterTag(tag);
            // If not selecting todo tag, reset filters below
            if (tag !== 'todo') {
                if (this.props.filterTodoMyTasks) {
                    this.props.onSetFilterTodoMyTasks(false);
                }
                if (this.props.filterTodoDistanceToMe) {
                    this.props.onSetFilterTodoDistanceToMe(false);
                }
            }
        } else {
            this.props.onSetFilterTag('');
            // If deselecting todo tag, reset filters below
            if (tag === 'todo') {
                if (this.props.filterTodoMyTasks) {
                    this.props.onSetFilterTodoMyTasks(false);
                }
                if (this.props.filterTodoDistanceToMe) {
                    this.props.onSetFilterTodoDistanceToMe(false);
                }
            }
        }
        // Send event to Analytics
        ReactGA.event({
            category: 'NotesWidget',
            action: `Filter tag changed to: ${tag}`,
            label: `User: ${this.props.currentAuthUser.name}`
        });
    }

    handleFilterTodoOrder = (tag) => {
        // Order logic function
        if (tag === "myTasks") {
            this.props.onSetFilterTodoMyTasks(!this.props.filterTodoMyTasks);
        } else if (tag === "myPosition") {
            if (!this.props.filterTodoDistanceToMe) {
                this.setState({ loadingCloseToMe: true });
            } else {
                this.setState({ loadingCloseToMe: false });
            }
            // Set current position in state
            let options = {
                enableHighAccuracy: true,
                timeout: 20000,
                maximumAge: 0
            }
            navigator.geolocation.getCurrentPosition(this.getPosSuccess, this.getPosError, options);
            // Set sorting state in reducer
            this.props.onSetFilterTodoDistanceToMe(!this.props.filterTodoDistanceToMe);
        }
        // Send event to Analytics
        ReactGA.event({
            category: 'NotesWidget',
            action: `Set todo filter order based on tag: ${tag}`,
            label: `User: ${this.props.currentAuthUser.name}`
        });
    }

    getPosSuccess = (pos) => {
        this.setState({ myCurrentPosition: pos.coords, loadingCloseToMe: false });
    }

    getPosError = (err) => {
        // Check for error type
        if (err.code === 1) {
            this.props.onEnqueueSnackbar({
                message: 'Enheden eller browseren har ikke adgang til din position, tjek evt. indstillinger!',
                options: {
                    key: new Date().getTime() + Math.random(),
                    variant: 'warning',
                },
            });
        } else {
            this.props.onEnqueueSnackbar({
                message: 'Kunne ikke finde din position på nuværende tidspunkt, prøv igen senere!',
                options: {
                    key: new Date().getTime() + Math.random(),
                    variant: 'warning',
                },
            });
        }
        this.setState({ loadingCloseToMe: false });
    }

    handleFilterTodoStatus = (status) => {
        if (status !== this.props.filterTodoStatus) {
            this.props.onSetFilterTodoStatus(status);
        } else {
            this.props.onSetFilterTodoStatus('');
        }
        // Send event to Analytics
        ReactGA.event({
            category: 'NotesWidget',
            action: `Set todo filter status: ${status}`,
            label: `User: ${this.props.currentAuthUser.name}`
        });
    }

    sortAccordingToDistance = (a, b, pos) => {
        // return 0 if equal
        // return 1 if a > b 
        // return -1 if a < b
        const p1 = { lat: a.latlng.lat, lng: a.latlng.lng };
        const p2 = { lat: b.latlng.lat, lng: b.latlng.lng };
        const pPos = { lat: pos.latitude, lng: pos.longitude };
        // Distance to a
        const distA = getDistanceFromLatLngInKm(pPos, p1);
        // Distance to b
        const distB = getDistanceFromLatLngInKm(pPos, p2);
        return distA === distB ? 0 : distA > distB ? 1 : -1;
    }

    renderFilterTag(config, tag, tagLabel, number) {
        const { classes } = this.props;
        let tagLabelTest = tagLabel;
        if (tagLabelTest === "Dalgas") {
            tagLabelTest = "hededanmark";
        }
        if (config) {
            return (
                <Tooltip title={`Her filtrerer du efter kategorien ${tagLabel}`} aria-label="Luk sidebaren">
                    <Chip
                        avatar={<Avatar style={{ backgroundColor: this.props.filterTag === tag ? '#5EBD3E' : '#EEEEEE', color: this.props.filterTag === tag ? 'white' : '#808080' }}>{number}</Avatar>}
                        onClick={() => this.handleFilterTagClick(tag)}
                        clickable
                        label={tagLabel}
                        className={classes.chip}
                        color={this.props.filterTag === tag ? 'primary' : 'default'}
                        variant="outlined"
                    />
                </Tooltip>
            )
        } else {
            return null
        }
    }

    renderTaskPlanningTag(tagLabel, filterType, filterInput, icon, active) {
        const { classes } = this.props;
        if (filterType === 'handleFilterTodoStatus') {
            return (
                <Tooltip title={`Her filtrerer du efter kategorien ${tagLabel}`} aria-label="Luk sidebaren">
                    <Chip
                        //avatar={<Avatar style={{ backgroundColor: this.props.filterTag === tag ? '#5EBD3E' : '#EEEEEE', color: this.props.filterTag === tag ? 'white' : '#808080' }}>{number}</Avatar>}
                        onClick={() => this.handleFilterTodoStatus(tagLabel)}
                        clickable
                        label={tagLabel}
                        className={classes.chip}
                        color={this.props.filterTodoStatus === tagLabel ? 'primary' : 'default'}
                        variant="outlined"
                    />
                </Tooltip>
            )
        } else if (filterType === 'handleFilterTodoOrder') {
            return (
                <Tooltip title={`Her filtrerer du efter kategorien ${tagLabel}`} aria-label="Luk sidebaren">
                    <Chip
                        avatar={icon}
                        onClick={() => this.handleFilterTodoOrder(filterInput)}
                        clickable
                        label={tagLabel}
                        className={classes.chip}
                        color={active ? 'primary' : 'default'}
                        variant="outlined"
                    />
                </Tooltip>
            )
        } else {
            return null
        }
    }

    notesList() {
        const { classes, notes } = this.props;
        let ntsArray = null;

        // Der er ingen kunder tilknyttet, derfor kan der ikke hentes noter
        if (notes === null && this.props.customerIdList.length < 1) {
            return (
                <ExpansionPanelDetails className={classes.cardContent}>
                    <div style={{ maxHeight: 80 }}>
                        <DialogContentText>
                            Der er ingen skove tilknyttet, derfor kan der ikke hentes noter
                        </DialogContentText>
                    </div>
                </ExpansionPanelDetails>
            )
        }

        // I gang med at hente
        if (notes === null) {
            return (
                <ExpansionPanelDetails className={classes.cardContent}>
                    <div style={{ height: 60, display: 'flex', justifyContent: 'center' }}>
                        <CircularSpinner />
                    </div>
                </ExpansionPanelDetails>
            );
        }

        if (notes !== null) {
            if (this.props.selectedForest && this.props.notes[this.props.selectedForest]) {
                ntsArray = Object.values(this.props.notes[this.props.selectedForest]).map(el => {
                    return el;
                }).flat()
            } else {
                ntsArray = Object.values(this.props.notes).map(el => {
                    return el;
                }).flat()
            }

            // Der er ingen gemte noter
            if (ntsArray.length < 1) {
                return (
                    <ExpansionPanelDetails className={classes.cardContent}>
                        <div style={{ maxHeight: 40 }}>
                            <DialogContentText>
                                Der er ingen gemte noter
                            </DialogContentText>
                        </div>
                    </ExpansionPanelDetails>
                )
            }
        }

        // Number of notes
        let numTodo = 0;
        let numSkoven = 0;
        let numJagt = 0;
        let numBilleder = 0;
        let numAndet = 0;
        let numPrivat = 0;
        let numOwners = 0;
        let numHedeDanmark = 0;
        let num2019 = 0;
        let num2020 = 0;
        let num2021 = 0;
        let num2022 = 0;
        let num2023 = 0;
        let numOtherUser = 0;
        // Filter out notes that are not private and todo notes that are archived and set number of notes
        ntsArray = ntsArray.filter(item => {
            // Calculate number of different notes
            if (item.private) {
                if (item.userUID === this.props.currentAuthUser.id) {
                    numPrivat += 1;
                    numSkoven += item.tag === 'skoven' ? 1 : 0;
                    numJagt += item.tag === 'jagt' ? 1 : 0;
                    numBilleder += item.tag === 'billeder' ? 1 : 0;
                    numAndet += item.tag === 'andet' ? 1 : 0;
                    numHedeDanmark += item.tag === 'hededanmark' ? 1 : 0;
                    if (item.tag === 'todo') {
                        if (item.todoStatus && item.todoStatus !== 'Arkiveret') {
                            numTodo += 1;
                            num2019 += ((new Date(item.creationDate ? item.creationDate : item.date)).getFullYear()).toString() === "2019" ? 1 : 0;
                            num2020 += ((new Date(item.creationDate ? item.creationDate : item.date)).getFullYear()).toString() === '2020' ? 1 : 0;
                            num2021 += ((new Date(item.creationDate ? item.creationDate : item.date)).getFullYear()).toString() === '2021' ? 1 : 0;
                            num2022 += ((new Date(item.creationDate ? item.creationDate : item.date)).getFullYear()).toString() === '2022' ? 1 : 0;
                            num2023 += ((new Date(item.creationDate ? item.creationDate : item.date)).getFullYear()).toString() === '2023' ? 1 : 0;
                            return item;
                        }
                    } else {
                        num2019 += ((new Date(item.creationDate ? item.creationDate : item.date)).getFullYear()).toString() === "2019" ? 1 : 0;
                        num2020 += ((new Date(item.creationDate ? item.creationDate : item.date)).getFullYear()).toString() === '2020' ? 1 : 0;
                        num2021 += ((new Date(item.creationDate ? item.creationDate : item.date)).getFullYear()).toString() === '2021' ? 1 : 0;
                        num2022 += ((new Date(item.creationDate ? item.creationDate : item.date)).getFullYear()).toString() === '2022' ? 1 : 0;
                        num2023 += ((new Date(item.creationDate ? item.creationDate : item.date)).getFullYear()).toString() === '2023' ? 1 : 0;
                        return item;
                    }
                } else {
                    numOtherUser += 1;
                }
            } else {
                numSkoven += item.tag === 'skoven' ? 1 : 0;
                numJagt += item.tag === 'jagt' ? 1 : 0;
                numBilleder += item.tag === 'billeder' ? 1 : 0;
                numAndet += item.tag === 'andet' ? 1 : 0;
                numHedeDanmark += item.tag === 'hededanmark' ? 1 : 0;
                if (item.tag === 'todo') {
                    if (item.todoStatus && item.todoStatus !== 'Arkiveret') {
                        numTodo += 1;
                        num2019 += ((new Date(item.creationDate ? item.creationDate : item.date)).getFullYear()).toString() === '2019' ? 1 : 0;
                        num2020 += ((new Date(item.creationDate ? item.creationDate : item.date)).getFullYear()).toString() === '2020' ? 1 : 0;
                        num2021 += ((new Date(item.creationDate ? item.creationDate : item.date)).getFullYear()).toString() === '2021' ? 1 : 0;
                        num2022 += ((new Date(item.creationDate ? item.creationDate : item.date)).getFullYear()).toString() === '2022' ? 1 : 0;
                        num2023 += ((new Date(item.creationDate ? item.creationDate : item.date)).getFullYear()).toString() === '2023' ? 1 : 0;
                        return item;
                    }
                } else if (item.tag === 'skovejere') {
                    if (this.props.currentAuthUser.userRole === 'forestOwner') {
                        numOwners += item.tag === 'skovejere' ? 1 : 0;
                        return item;
                    } else {
                        numOtherUser += 1;
                    }
                } else {
                    num2019 += ((new Date(item.creationDate ? item.creationDate : item.date)).getFullYear()).toString() === '2019' ? 1 : 0;
                    num2020 += ((new Date(item.creationDate ? item.creationDate : item.date)).getFullYear()).toString() === '2020' ? 1 : 0;
                    num2021 += ((new Date(item.creationDate ? item.creationDate : item.date)).getFullYear()).toString() === '2021' ? 1 : 0;
                    num2022 += ((new Date(item.creationDate ? item.creationDate : item.date)).getFullYear()).toString() === '2022' ? 1 : 0;
                    num2023 += ((new Date(item.creationDate ? item.creationDate : item.date)).getFullYear()).toString() === '2023' ? 1 : 0;
                    return item;
                }
            }
        })

        // Sort and filter notes list according to tag
        if (this.props.filterTag === 'todo') {
            // Remove archived todo tasks from the list
            // ntsArray = ntsArray.filter(item => {
            //     return item.todoStatus && item.todoStatus !== 'Arkiveret';
            // })
            if (this.props.filterTodoDistanceToMe && this.state.myCurrentPosition) {
                // Sort list according to distance to my position
                ntsArray.sort((a, b) => this.sortAccordingToDistance(a, b, this.state.myCurrentPosition));

            } else {
                // sort according to priority from Kanban board
                ntsArray = ntsArray.sort((a, b) => ((a.priority ? a.priority : 0) - (b.priority ? b.priority : 0)));
            }
        } else {
            // Default sort according to date
            ntsArray = ntsArray.sort((a, b) => Date.parse(new Date(b.creationData ? b.creationDate : b.date)) - Date.parse(new Date(a.creationData ? a.creationDate : a.date)));
        }

        // Filter by my tasks
        if (this.props.filterTodoMyTasks) {
            ntsArray = ntsArray.filter(item => {
                return item.responsible && item.responsible.includes(this.props.currentAuthUser.name);
            })
        }

        // Filter by tag
        if (this.props.filterTag !== '') {
            if (this.props.filterTag === '2019' || this.props.filterTag === '2020' || this.props.filterTag === '2021' || this.props.filterTag === '2022' || this.props.filterTag === '2023') {
                ntsArray = ntsArray.filter(list => this.props.filterTag === ((new Date(list.creationDate ? list.creationDate : list.date)).getFullYear()).toString())
            } else if (this.props.filterTag === 'todo') {
                // Check todo filter
                switch (this.props.filterTodoStatus) {
                    case 'Ikke planlagt': ntsArray = ntsArray.filter(item => {
                        return (item.tag === 'todo' && item.todoStatus === 'Ikke planlagt');
                    }); break;
                    case 'Ikke startet': ntsArray = ntsArray.filter(item => {
                        return (item.tag === 'todo' && item.todoStatus === 'Ikke startet');
                    }); break;
                    case 'I gang': ntsArray = ntsArray.filter(item => {
                        return (item.tag === 'todo' && item.todoStatus === 'I gang');
                    }); break;
                    case 'Udført': ntsArray = ntsArray.filter(item => {
                        return (item.tag === 'todo' && item.todoStatus === 'Udført');
                    }); break;
                    case '': ntsArray = ntsArray.filter(item => {
                        return (item.tag === 'todo');
                    }); break;
                    default: ntsArray = ntsArray.filter(item => {
                        return (item.tag === 'todo');
                    }); break;
                }
            } else if (this.props.filterTag === 'privat') {
                ntsArray = ntsArray.filter(item => {
                    return item.tag === 'privat' || item.private;
                });
            } else {
                ntsArray = ntsArray.filter(list => this.props.filterTag === list.tag);
            }
        }

        // Set personal filter status and text
        let personalFilterActive = this.props.config.taskPlanning.filter.myTasks === 'enabled' || this.props.config.taskPlanning.filter.closeToMe === 'enabled';
        let personalFilterText = "Ansvar";
        if (this.props.config.taskPlanning.filter.myTasks === 'enabled' && this.props.config.taskPlanning.filter.closeToMe === 'enabled') {
            personalFilterText = "Ansvar og afstand";
        } else if (this.props.config.taskPlanning.filter.closeToMe === 'enabled') {
            personalFilterText = "Afstand";
        }

        // Set length of notes array
        let N = ntsArray.length;
        return (
            <div>
                <div style={{ marginTop: 0, marginLeft: 14, marginRight: 16, marginBottom: 4 }}>
                    <Typography
                        variant="caption"
                        color="textSecondary"
                        style={{ margin: '2px 0px 2px 2px' }}
                    >
                        Kategorier
                    </Typography >

                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                        {/* <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between' }}> */}
                        {this.renderFilterTag(this.props.config.todoTag === 'enabled', 'todo', 'Todo', numTodo)}

                        {this.renderFilterTag(this.props.config.forestTag === 'enabled', 'skoven', 'Skoven', numSkoven)}

                        {this.renderFilterTag(this.props.config.huntingTag === 'enabled', 'jagt', 'Jagt', numJagt)}

                        {this.renderFilterTag(this.props.config.imagesTag === 'enabled', 'billeder', 'Billeder', numBilleder)}

                        {this.renderFilterTag(this.props.config.otherTag === 'enabled', 'andet', 'Andet', numAndet)}

                        {this.renderFilterTag(this.props.config.privateTag === 'enabled', 'privat', 'Privat', numPrivat)}

                        {this.renderFilterTag(this.props.config.ownersTag === 'enabled', 'skovejere', 'Skovejere', numOwners)}

                        {this.renderFilterTag(this.props.config.hdTag === 'enabled', 'hededanmark', 'Dalgas', numHedeDanmark)}

                        {/* Year-section, out when task planning is active */}
                        {this.renderFilterTag(this.props.config.yearTag === 'enabled', '2019', '2019', num2019)}

                        {this.renderFilterTag(this.props.config.yearTag === 'enabled', '2020', '2020', num2020)}

                        {this.renderFilterTag(this.props.config.yearTag === 'enabled', '2021', '2021', num2021)}

                        {this.renderFilterTag(this.props.config.yearTag === 'enabled', '2022', '2022', num2022)}
                        
                        {this.renderFilterTag(this.props.config.yearTag === 'enabled', '2023', '2023', num2023)}

                        {this.props.selectedForest && <Typography
                            variant="caption"
                            color="textSecondary"
                            style={{ margin: '2px 0px 2px 2px' }}
                        >
                            {`Yderligere ${numOtherUser} ${numOtherUser === 1 ? 'privat note' : 'private noter'} til denne skov`}
                        </Typography >}
                    </div>

                    {/* Task filter */}
                    {personalFilterActive && this.props.filterTag === 'todo' && <div>
                        <Typography
                            variant="caption"
                            color="textSecondary"
                            style={{ margin: '2px 0px 2px 2px' }}
                        >
                            {personalFilterText}
                        </Typography >

                        <div style={{ display: 'flex' }}>
                            {this.props.config.taskPlanning.filter.myTasks === 'enabled' && this.renderTaskPlanningTag('Mine opgaver', 'handleFilterTodoOrder', 'myTasks', <HowToRegRoundedIcon style={{ marginLeft: 6, color: this.props.filterTodoMyTasks ? '#5EBD3E' : '#808080', backgroundColor: 'transparent', width: 20, height: 20 }} />, this.props.filterTodoMyTasks)}

                            {this.props.config.taskPlanning.filter.closeToMe === 'enabled' && this.renderTaskPlanningTag('Tæt på mig', 'handleFilterTodoOrder', 'myPosition', (this.state.loadingCloseToMe ? <CircularProgress size={24} style={{ color: '#5EBD3E', backgroundColor: 'transparent' }} /> : <PinDropRoundedIcon style={{ marginLeft: 6, color: this.props.filterTodoDistanceToMe ? '#5EBD3E' : '#808080', backgroundColor: 'transparent', width: 20, height: 20 }} />), this.props.filterTodoDistanceToMe)}
                        </div>
                    </div>}

                    {this.props.filterTag === 'todo' && <div>
                        <Typography
                            variant="caption"
                            color="textSecondary"
                            style={{ margin: '2px 0px 2px 2px' }}
                        >
                            Opgavestatus
                        </Typography >

                        <div style={{ display: 'flex' }}>
                            {this.props.config.taskPlanning.filter.notPlanned === 'enabled' && this.renderTaskPlanningTag('Ikke planlagt', 'handleFilterTodoStatus')}

                            {this.props.config.taskPlanning.filter.notStarted === 'enabled' && this.renderTaskPlanningTag('Ikke startet', 'handleFilterTodoStatus')}

                            {this.props.config.taskPlanning.filter.started === 'enabled' && this.renderTaskPlanningTag('I gang', 'handleFilterTodoStatus')}

                            {this.props.config.taskPlanning.filter.done === 'enabled' && this.renderTaskPlanningTag('Udført', 'handleFilterTodoStatus')}
                        </div>
                    </div>}
                </div>

                <Divider style={{ marginTop: 0, marginBottom: 0, marginLeft: 16, marginRight: 16, }} />

                <ExpansionPanelDetails className={classes.cardContent}>
                    <List dense={this.state.dense} style={{ padding: 0 }}>
                        {this.displayNotesList(ntsArray, N)}
                    </List>
                </ExpansionPanelDetails>

                <Divider style={{ marginTop: 0, marginBottom: 0, marginLeft: 16, marginRight: 16, }} />

                {(N > 3) &&
                    <Typography
                        variant="body2"
                        align="center"
                        style={{ color: '#6A6A6A', marginTop: 16, marginLeft: 16, marginRight: 16, marginBottom: 16 }}
                    >
                        Listen er scrollbar <InfoIcon style={{ marginBottom: -8, color: '#9A9A9A' }} />
                    </Typography>}

                {(N <= 3) && <div style={{ height: 16 }} />}
            </div>
        )
    }

    expandAction() {
        this.setState({ open: this.state.open ? false : true });
        cookies.set('notesWidgetState', this.state.open ? 'close' : 'open', { path: '/' });
        // Send event to Analytics
        ReactGA.event({
            category: 'NotesWidget',
            action: `NotesWidget: ${this.state.open ? 'close' : 'open'}`,
            label: `User: ${this.props.currentAuthUser.name}`
        });
    }

    render() {
        const { notes } = this.props;
        let notesListDisplay = this.props.litraNr ? this.filterNoteListByLitra(this.props.litraNr) : notes;

        return (
            <div>
                <ExpansionPanel
                    expanded={this.state.open}
                    onChange={() => this.expandAction()}
                >
                    <ExpansionPanelSummary style={{ paddingLeft: 16, paddingRight: 16 }} expandIcon={<ExpandMoreIcon />}>
                        <Typography
                            variant="h5"
                            style={{ marginRight: 16 }}
                        >
                            Noter
                        </Typography >
                    </ExpansionPanelSummary>

                    {this.notesList(notesListDisplay)}
                </ExpansionPanel>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        notes: state.notes.Notes,
        filterTag: state.notes.filterTag,
        filterTodoMyTasks: state.notes.filterTodoMyTasks,
        filterTodoDistanceToMe: state.notes.filterTodoDistanceToMe,
        filterTodoStatus: state.notes.filterTodoStatus,
        err: state.notes.error,
        customerIdList: state.customer.customerIdList,
        customerList: state.customer.customerList,
        selectedForest: state.customer.currentlySelectedForestId,
        currentAuthUser: state.user.currentAuthUser,
        config: state.appConfig.notesWidget,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onSetFilterTag: (tag) => dispatch(actions.setFilterTag(tag)),
        onSetFilterTodoMyTasks: (state) => dispatch(actions.setFilterTodoMyTasks(state)),
        onSetFilterTodoDistanceToMe: (state) => dispatch(actions.setFilterTodoDistanceToMe(state)),
        onSetFilterTodoStatus: (status) => dispatch(actions.setFilterTodoStatus(status)),
        onSetFlyToNoteData: (noteData) => dispatch(actions.setFlyToNoteData(noteData)),
        onEnqueueSnackbar: (message, options) => dispatch(actions.enqueueSnackbar(message, options)),
    };
}

NotesWidget.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(NotesWidget)));


